import { Card } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react';
import isNil from 'lodash/isNil';

import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import LabelValue, { LabelValueItem } from '../LabelValue/LabelValue';
import { getSlidersByDeviceType, useLabelValueRealtimeItemsByDeviceType } from './RealtimeData.utils';

const RealtimeData = observer(({ entity }: { entity: Entity }) => {
  const { connectivity } = entity;

  const sliders = getSlidersByDeviceType(entity);
  const labelValueRealtimeItems = useLabelValueRealtimeItemsByDeviceType(entity);

  return (
    (!isNil(sliders) || !!labelValueRealtimeItems.length) && (
      <Card title={t('realTimeData')}>
        {sliders}
        <div className="label-value-container real-time-data-container">
          {labelValueRealtimeItems.map((item: LabelValueItem) => (
            <LabelValue
              key={item.label}
              label={item.label}
              value={item.value}
              unit={item.unit}
              isLarge
              connectivity={connectivity}
              displayValueByConnectivity
            />
          ))}
        </div>
      </Card>
    )
  );
});

export default RealtimeData;
